import * as z from "zod";

const PaymentMethodSummarySchema = z.object({
  type: z.string(),
  last4: z.string().nullable(),
  brand: z.string().nullable(),
  expMonth: z.number().nullable(),
  expYear: z.number().nullable(),
});

export type PaymentMethodSummary = z.infer<typeof PaymentMethodSummarySchema>;

export const getBillingStatus = {
  name: "getBillingStatus" as const,
  input: z.object({}),
  output: z.object({
    hasStripeCustomer: z.boolean(),
    hasPaymentMethod: z.boolean(),
    paymentMethodSummary: PaymentMethodSummarySchema.nullable(),
  }),
};

export const createBillingSetupIntent = {
  name: "createBillingSetupIntent" as const,
  input: z.object({ country: z.string().optional() }),
  output: z.object({
    clientSecret: z.string(),
    bankPaymentMethod: z.string().nullable(),
  }),
};

export const saveBillingPaymentMethod = {
  name: "saveBillingPaymentMethod" as const,
  input: z.object({ paymentMethodId: z.string() }),
  output: PaymentMethodSummarySchema,
};
